<template>
  <div class="main-container">
    <Tabs v-model="tab">
      <TabPane label="启动页配置" name="1"></TabPane>
      <TabPane label="广告页配置" name="3"></TabPane>
      <TabPane label="模块配置" name="2"></TabPane>
    </Tabs>
    <startImage v-if="tab == 1"></startImage>
    <moduleConfig v-if="tab == 2"></moduleConfig>
    <bannerConfig v-if="tab == 3"></bannerConfig>
  </div>
</template>
<script>
import moduleConfig from "./moduleConfig";
import bannerConfig from "./bannerConfig";
import startImage from "./startImage";
export default {
  components: {
    moduleConfig,
    bannerConfig,
    startImage,
  },
  data: () => ({
    tab: "1",
    tabList: [],
  }),
  mounted() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.main-container {
  position: relative;
  /deep/ .ivu-tabs-tab {
    padding-top: 0 !important;
    font-size: 14px;
  }
  /deep/ {
    .ivu-tabs-bar {
      border-bottom: 1px solid #ececec;
    }
    .ivu-tabs-ink-bar {
      display: none;
    }
    .ivu-tabs-tab {
      padding: 9px 0 10px;
      margin-right: 44px;
      font-size: 14px;
      color: #515c6f;
    }
    .ivu-tabs-tab-active {
      position: relative;
      color: #236dff;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        bottom: 1px;
        height: 2px;
        width: 100%;
        background-color: #236dff;
      }
    }
  }
}
</style>